module.exports = __webpack_public_path__ + "assets/img/ic-popup-alert.f6515257.svg";